import i18n from 'i18next';
import { get, toString } from 'lodash';

import { SubmitApplicationError } from '../types/SubmitApplicationError';
import { SubmitApplicationErrorResponseReason } from '../types/SubmitApplicationErrorResponseReason';

export const getSubmitApplicationErrorMessage = (
  error: SubmitApplicationError,
): string => {
  const errorStatus = get(error, 'status');
  const errorReasons: SubmitApplicationErrorResponseReason[] = get(
    error,
    'response.data.errors',
    [],
  );

  const dateOfBirthError = errorReasons.find(
    (reason) => reason.name === 'birthDate',
  );

  if (dateOfBirthError) {
    return i18n.t('errors.submitApplication.dateOfBirthInvalidMessage');
  }

  return get(
    i18n.t('errors.submitApplication.statusMessage'),
    toString(errorStatus),
    i18n.t('errors.submitApplication.defaultMessage'),
  );
};
